import type { ApiAction, ApiParameter } from '@/types/api'; // Adjust path if your tsconfig aliases are different

export const generateApiSchemaObject = (
  apiName: string, 
  apiDescription: string, 
  documentationUrl: string, 
  potentialActions: ApiAction[], 
  apiUrl?: string
) => ({
  '@context': 'https://schema.org',
  '@type': 'APIReference',
  name: apiName,
  description: apiDescription,
  url: documentationUrl,
  potentialAction: potentialActions.map(action => ({
    '@type': action.type === 'HttpRequestAction' ? 'ConsumeAction' : action.type,
    name: action.name,
    description: action.description,
    target: {
      '@type': 'EntryPoint',
      urlTemplate: action.target,
      httpMethod: action.method || 'GET', // Default to GET if not specified
    },
    expects: action.expects?.map(param => ({
      '@type': 'PropertyValueSpecification',
      name: param.name,
      description: param.description,
      valueRequired: param.valueRequired,
      valueName: param.valueName, 
      valuePattern: param.valuePattern,
      defaultValue: param.defaultValue,
      minValue: param.minValue,
      maxValue: param.maxValue,
      stepValue: param.stepValue,
      multipleValues: param.multipleValues,
      readonlyValue: param.readonlyValue,
      ...(param.accessLevel && { isAccessibleForFree: param.accessLevel === 'free' }),
    })),
  })),
  ...(apiUrl && { provider: { 
    '@type': 'Organization', // Or 'Service' depending on context
    name: 'Tomorrow.io', // Replace if needed
    url: apiUrl
  }})
}); 